import { Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import React from "react";
import { View } from "../components";
import * as styleGlobal from "../infra/styleGlobal";
const ContainerFields = props => {
  let { classes, style, children, key, paper } = props;
  return (
    <Grid container justify="center" spacing={0}>
      <Grid item  {...styleGlobal.orientacaoGrid1}>
        <View style={styleGlobal.styles.container1}>
          {children}
        </View>
      </Grid>
    </Grid>
  )
};

export const gsUI = theme => ({
});


export default (withStyles(gsUI)(ContainerFields));
